<template>
  <v-form ref="forgotForm"
          @submit.prevent="reset">
    <v-card class="elevation-12">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Reset Password</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-text-field id="username"
                      name="username"
                      label="Username"
                      ref="username"
                      v-model="username"
                      outlined
                      validate-on-blur
                      :error-messages="serverError"
                      :rules="rules"
                      @focus="serverError = ''" />
      </v-card-text>
      <v-card-actions class="px-4">
        <v-btn type="submit"
               color="primary"
               large ripple
               :loading="loading">Send Email</v-btn>
        <v-btn class="ml-auto"
               large ripple
               text link
               :to="{ name: 'login' }">Back to Login</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'ForgotForm',
  data() {
    return {
      username: '',
      rules: [
        (v) => rules.required(v, 'Username is required'),
        (v) => rules.email(v, 'A valid email is required'),
      ],
      serverError: '',
      loading: false,
    };
  },
  methods: {
    async reset() {
      if (this.$refs.forgotForm.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch('get', {
            api: 'User/IForgot',
            params: {
              Email: this.username,
            },
          });
          this.$emit('snackbar', `An email has been sent to ${this.username}`);
          this.$router.push({ name: 'login' });
        } catch (e) {
          this.serverError = e.response.data.Message;
        }
        this.loading = false;
      }
    },
  },
};
</script>
